export default {
  Allowable: 16.28,
  TravelMin: 16.28,
  TravelMax: 68.0,
};
